// import services
import { Toastr } from "@revvsales/components";
import { addTemplateComponentService } from "../actions/DocumentTemplateActions/templateService";
import { addDocumentComponentService } from "../actions/DocumentActions/services";
import {
  restoreSection,
  deleteSection,
} from "../actions/DocumentActions/index";

import { DOCUMENT_MODE } from "../constants/document";
import { DOCUMENTS } from "../constants";
import BaseCommand from "./baseCommand";
import { getContentForComponent } from "../utils/documentUtils";

const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;

class AddComponentCommand extends BaseCommand {
  constructor(componentData) {
    super();
    this.componentData = componentData;
  }

  execute() {
    const {
      component,
      rowIndex,
      colIndex,
      newRow,
      headerFooterType,
      layout,
      mode,
      docNo,
      docID,
      dbRowIndex,
      dbColIndex,
    } = this.componentData;

    if (this.isRedo) {
      // Scroll section into view when do Redo
      if (component) {
        this.scrollIntoView(component.id);
      }
      restoreSection(mode)(docNo || docID, component, this.newLayout);
      this.componentData.addDocumentComponentAction(
        this.newLayout,
        component,
        dbRowIndex,
        dbColIndex,
        headerFooterType,
        true,
      );
      if (
        mode === DOCUMENT_MODE.DOCUMENT &&
        component.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER
      ) {
        this.componentData.addDealTableTab();
      }
    } else {
      this.newLayout = [...layout];
      if (newRow) {
        this.newLayout.splice(rowIndex, 0, [component.id]);
      } else if (!newRow) {
        const rowIDs = [...this.newLayout[rowIndex]];
        rowIDs.splice(colIndex, 0, component.id);
        this.newLayout[rowIndex] = rowIDs;
      }

      // Updating the redux before the add component service to
      // avoid the slow user exeperience
      this.componentData.addDocumentComponentAction(
        this.newLayout,
        component,
        dbRowIndex,
        dbColIndex,
        headerFooterType,
      );

      const componentPayload = {
        component: {
          content: getContentForComponent(component, mode),
          row: dbRowIndex,
          col: dbColIndex,
          component_id: component.id,
        },
        new_row_added: newRow,
      };

      if (mode === DOCUMENT_MODE.DOCUMENT) {
        addDocumentComponentService(docNo || docID, [componentPayload])
          .then(() => {
            if (
              mode === DOCUMENT_MODE.DOCUMENT &&
              component.type === DOCUMENT_COMPONENT_TYPES.QUOTE_TABLE_WRAPPER
            ) {
              this.componentData.addDealTableTab();
            }
          })
          .catch(error => {
            console.error(`Document => _addNewComponent => Error : ${error}`);
            Toastr.showToastr({
              type: "failure",
              message: "Oops, Something went wrong!!",
              timeout: 3000,
            });
            setTimeout(() => {
              this.componentData.deleteDocumentComponentAction(component.id);
            }, 2000);
          });
      } else {
        addTemplateComponentService(docNo || docID, [componentPayload])
          .then(() => {})
          .catch(error => {
            console.error(`Document => _addNewComponent => Error : ${error}`);
            Toastr.showToastr({
              type: "failure",
              message: "Oops, Something went wrong!!",
              timeout: 3000,
            });
            setTimeout(() => {
              this.componentData.deleteDocumentComponentAction(component.id);
            }, 2000);
          });
      }
    }
  }

  undo() {
    const { component, mode, docID, docNo } = this.componentData;

    // Scroll section into view when do Undo
    if (component) {
      this.scrollIntoView(component.id);
    }
    deleteSection(mode)(docNo || docID, component);
    this.componentData.removeComponentInDocument(component.id);
    this.isRedo = true;
  }
}

export default AddComponentCommand;



// WEBPACK FOOTER //
// ./src/commands/addComponentCommand.js